import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { BillingComponent } from "./billing.component";

const routes = [
  { path: '', component: BillingComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BillingRoutingModule { }
